import React from 'react';
import { Trans } from 'react-i18next';
import { Switch, FormControlLabel } from '@mui/material';
import AdditionalInfo from '../AdditionalInfo';
import './SwitchWithInfoIcon.scss';

/**
 * @param {import('@mui/material').SwitchProps & {
 *   label: string;
 *   info: string;
 *   inputRef?: import('react').RefCallback<SwitchWithInfoIcon>;
 *   onBlur?: any;
 *   onFocus?: any;
 *   color?: 'primary' | 'secondary' | 'default';
 *   checked?: boolean;
 * }} param0
 */
const SwitchWithInfoIcon = ({
    label,
    info = '',
    inputRef,
    onBlur,
    onChange,
    onFocus,
    checked,
    ...props
}) => (
    <div className="core--switch-with-info-icon">
        <FormControlLabel
            label={label || ''}
            control={(
                <Switch
                    {...props}
                    inputRef={inputRef}
                    onBlur={onBlur}
                    checked={checked}
                    onChange={onChange}
                />
            )}
        />
        <AdditionalInfo>
            <Trans>
                {info}
            </Trans>
        </AdditionalInfo>
    </div>
);


export default SwitchWithInfoIcon;
